const getReviewItems = process => (
    process && Array.isArray(process.items) ? process.items : []
)

const findReviewItem = (process, itemId) => getReviewItems(process)
    .find(item => item && String(item.id) === String(itemId)) || null

const resolveSequentialReviewItem = (process, itemId = null) => {
    const items = getReviewItems(process)

    if (itemId !== null && typeof itemId !== 'undefined') {
        const requestedItem = findReviewItem(process, itemId)

        return requestedItem
            ? { item: requestedItem, error: null, complete: false }
            : { item: null, error: 'item-not-found', complete: false }
    }

    const pendingItem = items.find(item => item && item.status !== 'reviewed')
    if (pendingItem) {
        return { item: pendingItem, error: null, complete: false }
    }

    if (items.length > 0) {
        return { item: null, error: null, complete: true }
    }

    return { item: null, error: 'item-missing', complete: false }
}

const findAdjacentReviewItem = (process, itemId, offset) => {
    const items = getReviewItems(process)
    const currentIndex = items.findIndex(item => item && String(item.id) === String(itemId))
    const nextIndex = currentIndex + offset

    return currentIndex >= 0 && nextIndex >= 0 && nextIndex < items.length
        ? items[nextIndex]
        : null
}

const findNextUnreviewedItem = (process, itemId) => {
    const items = getReviewItems(process)
    const currentIndex = items.findIndex(item => item && String(item.id) === String(itemId))
    const afterCurrent = items.slice(currentIndex + 1)
        .find(item => item && item.status !== 'reviewed')
    const beforeCurrent = items.slice(0, Math.max(currentIndex, 0))
        .find(item => item && item.status !== 'reviewed')

    return afterCurrent || beforeCurrent || null
}

export {
    findAdjacentReviewItem,
    findNextUnreviewedItem,
    findReviewItem,
    getReviewItems,
    resolveSequentialReviewItem,
}
